import axios from 'axios'
import { ref } from 'vue'

const emptyDataset = () => ({ from: null, to: null, months: [], rows: [] })
const emptyCohort = () => ({ from: null, to: null, months: [], rows: [], total_created: 0, total_won: 0, total_rate: 0 })

/**
 * Statistiques "par demande" (snapshot client_request_stats) :
 * gagnés nets, dédupliqués, et taux de conversion par cohorte.
 * Le détail "tous les statuts par utilisateur" reste basé sur l'activité (activity_log).
 */
export function useRequestStatistics({ onError = () => {} } = {}) {
    const fetching = ref(false)

    const conversions = ref(emptyDataset())
    const centerCreations = ref(emptyDataset())
    const cohort = ref(emptyCohort())
    const userStatusBreakdown = ref(emptyDataset())
    const servicesByCenter = ref(emptyDataset())
    const clientCreations = ref(emptyDataset())

    const buildParams = (filters) => {
        const params = {}

        if (filters.centerId) params.center_id = filters.centerId
        if (filters.userId) params.user_id = filters.userId
        if (filters.from) params.from = filters.from
        if (filters.to) params.to = filters.to

        return params
    }

    const fetchAll = async (filters = {}) => {
        try {
            fetching.value = true
            const params = buildParams(filters)

            const [conv, creations, cohortData, breakdown, services, clients] = await Promise.all([
                axios.get('/api/request-statistics/conversions', { params }),
                axios.get('/api/request-statistics/center-creations', { params }),
                axios.get('/api/request-statistics/cohort-conversion', { params }),
                axios.get('/api/statistics/user-status-breakdown', { params }),
                axios.get('/api/request-statistics/services-by-center', { params }),
                axios.get('/api/statistics/client-creations', { params }),
            ])

            conversions.value = conv.data.data
            centerCreations.value = creations.data.data
            cohort.value = cohortData.data.data
            userStatusBreakdown.value = breakdown.data.data
            servicesByCenter.value = services.data.data
            clientCreations.value = clients.data.data
        } catch (error) {
            onError(error)
        } finally {
            fetching.value = false
        }
    }

    return {
        fetching,
        conversions,
        centerCreations,
        cohort,
        userStatusBreakdown,
        servicesByCenter,
        clientCreations,
        fetchAll,
    }
}
